import { render, staticRenderFns } from "./TheSnapshotBundleList.vue?vue&type=template&id=87bfe672&"
import script from "./TheSnapshotBundleList.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotBundleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports